import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CityListRequestBody, CityListResponse } from "./types";

export class CityListAPI extends BaseAPI<
    CityListRequestBody,
    CityListResponse
> {
    protected route = ApiRoutes.property.city;
    protected method = RequestMethod.GET;
};
